const nouns: string[] = [
  "Acorn",
  "Adventure",
  "Airplane",
  "Alien",
  "Alligator",
  "Alpaca",
  "Anchor",
  "Ant",
  "Bag",
  "Ball",
  "Balloon",
  "Banana",
  "Bandana",
  "Banjo",
  "Baseball",
  "Basket",
  "Basketball",
  "Bat",
  "Beach",
  "Bear",
  "Beaver",
  "Bed",
  "Bee",
  "Beetle",
  "Bicycle",
  "Bird",
  "Birdhouse",
  "Boat",
  "Book",
  "Bowtie",
  "Bridge",
  "Butterfly",
  "Button",
  "Cactus",
  "Camera",
  "Candle",
  "Canoe",
  "Car",
  "Carpet",
  "Carrot",
  "Castle",
  "Cat",
  "Cave",
  "Chair",
  "Chalk",
  "Chameleon",
  "Chicken",
  "City",
  "Clock",
  "Cloud",
  "Clownfish",
  "Coffee",
  "Coin",
  "Compass",
  "Computer",
  "Coral",
  "Cow",
  "Crayon",
  "Cricket",
  "Crocodile",
  "Cup",
  "Cupcake",
  "Desert",
  "Diamond",
  "Dinosaur",
  "Dog",
  "Dolphin",
  "Dragon",
  "Dragonfly",
  "Dream",
  "Duck",
  "Eagle",
  "Elephant",
  "Feather",
  "Firefly",
  "Fish",
  "Flag",
  "Flask",
  "Flower",
  "Flute",
  "Forest",
  "Fountain",
  "Fox",
  "Friend",
  "Frog",
  "Funnel",
  "Galaxy",
  "Giraffe",
  "Glass",
  "Glasses",
  "Glove",
  "Goat",
  "Grass",
  "Guitar",
  "Hat",
  "Helicopter",
  "Helmet",
  "Horse",
  "House",
  "Island",
  "Jacket",
  "Jellyfish",
  "Jungle",
  "Kangaroo",
  "Key",
  "Keychain",
  "King",
  "Knight",
  "Lamp",
  "Leaf",
  "Lighthouse",
  "Lion",
  "Llama",
  "Lock",
  "Map",
  "Marshmallow",
  "Microphone",
  "Mirror",
  "Monkey",
  "Moon",
  "Mountain",
  "Mouse",
  "Music",
  "Notebook",
  "Ocean",
  "Octopus",
  "Ostrich",
  "Paintbrush",
  "Pan",
  "Parrot",
  "Peacock",
  "Pen",
  "Penguin",
  "Phone",
  "Piano",
  "Pig",
  "Pineapple",
  "Pizza",
  "Planet",
  "Porch",
  "Potato",
  "Princess",
  "Pumpkin",
  "Puzzle",
  "Queen",
  "Rabbit",
  "Raccoon",
  "Rainbow",
  "River",
  "Road",
  // "Robot",
  "Rocket",
  "Saddle",
  "Sailboat",
  "Sandcastle",
  "Satellite",
  "Scarf",
  "Scooter",
  "Seagull",
  "Seashell",
  "Shark",
  "Sheep",
  "Shell",
  "Shield",
  "Ship",
  "Shirt",
  "Shoe",
  "Shovel",
  "Skate",
  "Skateboard",
  "Sky",
  "Skyscraper",
  "Smile",
  "Smiley",
  "Snail",
  "Snake",
  "Snowball",
  "Snowflake",
  "Snowman",
  "Socks",
  "Spaceship",
  "Spider",
  "Spoon",
  "Squirrel",
  "Stadium",
  "Stapler",
  "Star",
  "Starfish",
  "Suitcase",
  "Sun",
  "Sunflower",
  "Sunglasses",
  "Sunset",
  "Sweater",
  "Sword",
  "Table",
  "Tennis",
  "Tiger",
  "Time",
  "Toothbrush",
  "Tophat",
  "Toy",
  "Trampoline",
  "Treasure",
  "Tree",
  "Treehouse",
  "Trolley",
  "Tunnel",
  "Turtle",
  "Umbrella",
  "Valley",
  "Vase",
  "Village",
  "Violin",
  "Volcano",
  "Waterfall",
  "Wave",
  "Whale",
  "Whisk",
  "Whistle",
  "Wizard",
  "Wolf",
  "Zebra",
  "Zoo",
];

export default nouns;
